import { type IEventType } from '@interface/ICommon';
import { selectLocale } from '@store/commonSlice';
import { useAppSelector } from '@store/index';
import { setCookie } from '@utils/common';
import { EVENTTYPE_COOKIE_KEY } from '@utils/constants';
import { useEffect, useState, type ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { fetchData } from '../../hooks/data';

const EventType = ({ activeEvtType }: { activeEvtType: string | null }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [checkItems, setCheckItems] = useState<string[]>(['']);
    const [eventTypeList, setEventTypeList] = useState<IEventType[]>([]);
    const locale = useAppSelector(selectLocale);
    const { t } = useTranslation();

    useEffect(() => {
        fetchData('/tl/v2.0/game/schedule/type', { locale }).then((res) => {
            res.unshift({ contentType: undefined, eventType: undefined, prefix: '', name: t('I005') });
            setEventTypeList(res);
        });
    }, []);

    useEffect(() => {
        setCheckItems(!activeEvtType ? [''] : activeEvtType.split(','));
    }, [activeEvtType]);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const el = e.target;
        let result = '';
        let uniqueArr: string[] = [];

        if (el.value !== '') {
            if (el.checked) {
                const datarr: string[] = [...checkItems, el.value];
                uniqueArr = datarr.filter((it, idx) => {
                    if (it === '') return false;
                    return datarr.indexOf(it) === idx;
                });
            } else {
                uniqueArr = checkItems.filter((it) => it !== el.value);
            }
            result = uniqueArr.join(',');
        }
        searchParams.set('etype', result);
        setSearchParams(searchParams);
        setCookie(EVENTTYPE_COOKIE_KEY, result);
    };

    return (
        <div className="block border border-solid border-gray010 mb-[15px] mx-[20px] lg:mx-0">
            <legend className="hide-text">이벤트 종류 설정 영역</legend>
            <label className="text-base text-black068 block leading-[21px] bg-gray004 pt-[10px] pb-[13px] pl-[16px]">{t('I003')}</label>
            <div className='className="flex justify-between items-center pt-[12px] pl-[16px] pr-[16px]"'>
                {eventTypeList.map((it, idx) => {
                    const value = it.eventType !== undefined ? it.eventType + '_' + it.contentType : '';
                    return (
                        <div key={idx + value} className="mb-[12px]">
                            <input
                                className="hide-text"
                                type="checkbox"
                                id={`checkbox_${value}`}
                                name={`checkbox_${value}`}
                                value={value}
                                checked={checkItems.includes(value)}
                                onChange={onChange}
                            />
                            <label className="set-checkbox text-base text-black093 leading-[14px]" htmlFor={`checkbox_${value}`}>
                                <span className="align-middle">{it.prefix ? it.prefix + ' ' + it.name : it.name}</span>
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default EventType;
